  export function install(Vue, options) {
    Vue.prototype.$makeToast = function (variant = null,title,content,timer,href=null) {
                    this.$bvToast.toast(content, {
                      title: title,
                      variant: variant,
                      autoHideDelay: timer,
                      solid: true,
                      toaster:'b-toaster-top-center',
                      href:href
                    })
    }
  }

  export default install
